import * as React from "react";
import {
    DeleteButton,
    EditButton,
    required,
    Show, SimpleForm,
    TextInput, Toolbar,
    TopToolbar,
    SimpleShowLayout
} from 'react-admin';
import DeleteWithCustomConfirmButton from 'ra-delete-with-custom-confirm-button';
import Delete from '@material-ui/icons/Delete';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import checkPermission from "../../helpers/permission_handler";
import CustomAside from "../CustomAside/CustomAside";
import {Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

const PageTitle = ({record}) => {
    return <span>Types - View Type {record ? `${record.name}` : ''}</span>;
};

export const styles = {
    name: {display: 'inline-block'},
    type: {display: 'inline-block', marginLeft: 32},
};

const useStyles = makeStyles(styles);

const RoleShowActions = ({basePath, data, resource}) => (
    <TopToolbar>
        <EditButton basePath={basePath} record={data}/>
    </TopToolbar>
);

// Define your custom contents of confirm dialog
const DeleteConfirmContent = props => {
    return (
        <SimpleShowLayout {...props} />
    );
};

const CustomToolbar = ({permissions, ...props}) => (
    <Toolbar {...props} classes={useStyles()}>
        {permissions && checkPermission(permissions, {adminUserRole: ['delete']}) &&
        <DeleteWithCustomConfirmButton
            title={"Are you sure?"}
            content={DeleteConfirmContent}
            label='Delete'                  // label of delete button (default: 'Delete')
            confirmColor='warning'          // color of delete button ('warning' or 'primary', default: 'warning')
            ConfirmIcon={Delete}            // icon of delete button (default: 'Delete')
            cancel='Cancel'                 // label of cancel button (default: 'Cancel')
            CancelIcon={ErrorOutline}       // icon of cancel button (default: 'ErrorOutline')
            undoable={false}/>}
    </Toolbar>
);

export const TypeShow = ({permissions, ...props}) => {
    const classes = useStyles(props);
    return (
        <Show {...props} aside={<CustomAside {...props}/>} title={<PageTitle/>}
              actions={permissions && checkPermission(permissions, {adminUserRole: ['edit']}) ?
                  <RoleShowActions/> : <React.Fragment/>}>
            <SimpleForm
                toolbar={<CustomToolbar permissions={permissions}/>}
                variant="outlined"
                redirect={'/types'}
            >
                <TextInput
                    source="name"
                    validate={[required()]}
                    formClassName={classes.name}
                    disabled
                />
            </SimpleForm>
        </Show>
    );
};